'use client';

import React from 'react';
import Slider from '../content/slider/slider';
import STSHotelIcon from '../atoms/icons/sts_hotel';

const HotelImages = ({ blok, hotel }) => {
  const blockWidths = {
    '25%': 'w-1/2 md:w-1/4',
    '33%': 'w-1/2 md:w-1/3',
    '50%': 'w-full md:w-1/2',
    '66%': 'w-full md:w-2/3',
    '75%': 'w-full md:w-3/4',
    '100%': 'w-full col-span-12',
  };

  const imageBloks = hotel.images.map((img, index) => {
    const blokImage = {
      component: 'hotel_image',
      _uid: index,
      image: {
        id: img.id,
        alt: hotel.name,
      },
      width: '100%',
    };

    return blokImage;
  });

  const fakeSlider = {
    component: 'slider',
    _uid: `sliderUUid_${blok._uid}`,
    blocks: imageBloks,
    width: '100%',
    automaticSlide: true,
  };

  return (
    <div className={`${blockWidths[blok.width] || 'w-full col-span-12'}`}>
      <Slider blok={fakeSlider} />
      {hotel.sts_hotel && (
        <div className="absolute top-0 right-0 flex m-2 z-20">
          <div className="w-16">
            <STSHotelIcon />
          </div>
        </div>
      )}
    </div>
  );
};

export default HotelImages;
